import { render, staticRenderFns } from "./card-item.mpx?vue&type=template&id=fd195a7e&component=true&componentId=card-item5f98f9b0"
import script from "./card-item.mpx?vue&type=script&lang=js&component=true&componentId=card-item5f98f9b0"
export * from "./card-item.mpx?vue&type=script&lang=js&component=true&componentId=card-item5f98f9b0"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports